// src/components/onboarding/onboardingData.js


export const activitesOptions = [
  { label: "Sport / Bouger", emoji: "⚽" },
  { label: "Jeux vidéo / Gaming", emoji: "🎮" },
  { label: "Musique (écouter ou jouer)", emoji: "🎵" },
  { label: "Séries / Films / Anime", emoji: "🎬" },
  { label: "Créa (dessin, photo, vidéo...)", emoji: "🎨" },
  { label: "Lecture / Écriture", emoji: "📚" },
  { label: "Tech / Code", emoji: "💻" },
  { label: "Sorties / Amis", emoji: "👥" },
  { label: "Nature / Animaux", emoji: "🌿" },
  { label: "Bricolage / Fabriquer des trucs", emoji: "🔧" },
  { label: "Réseaux sociaux / Créer du contenu", emoji: "📱" },
  { label: "Autre chose", emoji: "✨" }
];

export const matieresParClasse = {
  "3eme": [
    "Français", "Maths", "Histoire-Géo", "Anglais",
    "Autre langue (espagnol, allemand...)", "Physique-Chimie", "SVT",
    "Techno", "Arts plastiques", "Musique", "Sport",
    "Latin / Grec", "Autre option"
  ],
  "seconde": [
    "Français", "Maths", "Histoire-Géo", "Anglais",
    "Autre langue (espagnol, allemand...)", "Physique-Chimie", "SVT",
    "SES", "SNT", "Arts", "Sport",
    "Latin / Grec", "Autre option"
  ],
  "premiere": [
    "Français", "Maths", "Histoire-Géo / Géopo", "Anglais",
    "Autre langue", "Physique-Chimie", "SVT",
    "SES", "NSI (info)", "HLP",
    "SI (sciences de l'ingé)", "Arts", "Sport", "Autre spé"
  ],
  "terminale": [
    "Philo", "Maths", "Histoire-Géo / Géopo", "Anglais",
    "Autre langue", "Physique-Chimie", "SVT",
    "SES", "NSI (info)", "HLP",
    "SI (sciences de l'ingé)", "Arts", "Sport", "Autre spé"
  ]
};

export const specialitesOptions = [
  "Maths",
  "Physique-Chimie",
  "SVT",
  "NSI (info)",
  "SI (sciences de l'ingé)",
  "SES",
  "HGGSP (géopolitique)",
  "HLP (lettres/philo)",
  "LLCE (langues)",
  "LLCA (latin/grec)",
  "Arts",
  "EPPCS (sport)",
  "Biologie-écologie"
];

export const metiersAvantOptionsLabel = (genre) => {
  const e = (genre === 'F' || genre === 'girl') ? 'e' : '';
  return `Quand j'étais petit${e}`
}

export const metiersAvantOptions = [
  { value: "oui", label: "J'avais des idées de métier" },
  { value: "non", label: "Non, rien de spécial" }
];

export const metiersAujourdhuiOptions = [
  { value: "pistes", label: "J'ai quelques pistes" },
  { value: "flou", label: "C'est encore flou" },
  { value: "stress", label: "Aucune idée et ca me stresse" },
  { value: "tranquille", label: "Aucune idée mais tranquille" }
];

export const getEtatPersoOptions = (genre) => {
  const isFeminin = genre === 'F' || genre === 'girl';
  return [
    { value: "curieux", label: isFeminin ? "Curieuse" : "Curieux", sub: "Envie de découvrir des trucs" },
    { value: "tranquille", label: "Tranquille", sub: `Pas ${isFeminin ? 'pressée' : 'pressé'}, ça viendra` },
    { value: "paume", label: `Un peu ${isFeminin ? 'paumée' : 'paumé'}`, sub: "Je ne sais pas par où commencer" },
    { value: "stresse", label: isFeminin ? "Stressée" : "Stressé", sub: "Ça me met la pression" }
  ];
};

export const etatExterieurOptions = [
  { value: "roule", label: "Ça roule", sub: "Pas trop de pression" },
  { value: "stress", label: "Y a du stress", sub: "On me met la pression" },
  { value: "chaud", label: "C'est chaud", sub: "Ça crée des tensions" }
];

export const attentesOptions = [
  "Découvrir des métiers que je ne connais pas",
  "Mieux me connaître (mes forces, ce qui me motive)",
  "Parler avec des pros qui font des métiers qui m'intriguent",
  "Avoir des infos claires sur les études et les filières",
  "Juste voir ce que ça donne"
];

export const ONBOARDING_STEPS = {
  INTRO: 0,
  ACTIVITES: 1,
  MATIERES: 2,
  SPECIALITES: 'specialites', // Uniquement pour premiere/terminale
  METIERS: 3,
  ETAT: 4,
  ATTENTES: 5,
  FIERTE: 6,
  FINAL: 7
};

export const TOTAL_STEPS = 6; // Nombre d'étapes avec barre de progression (sans intro et final)
